<script>
  import {Doughnut} from 'vue-chartjs'

  export default {
    name: "TipoPedido",
    extends: Doughnut,
    props: ['dados', 'pedidos'],

    computed: {
      chartData() {
        return this.dados;
      },
    },

    methods: {
      renderizarGrafico() {
        const data = {
          labels: ["Mesas", "Delivery", "Comandas", "Venda Rápida", "Balcão"],
          datasets: [{
            data: this.chartData,
            backgroundColor: ['#9454F0', '#1cc88a', '#f6c23e', '#2D3356', '#36b9cc'],
            hoverBackgroundColor: ['#9454F0', '#17a673', '#f6c23e', '#2D3356', '#36b9cc'],
            hoverBorderColor: "rgba(234, 236, 244, 1)"
          }],
        };

        const options = {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: -10
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }],
            yAxes: [{
              ticks: {
                display: false,
                beginAtZero: true
              },
              gridLines: {
                color: '#F8F9FC',
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false
              }
            }]
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            callbacks: {
              label: (item) => {
                const index = item.index
                let label = [];

                if (index === 1) {
                  label.push(`Entregas: ${this.pedidos[0]}`);
                  label.push(`Retiradas: ${this.pedidos[1]}`);
                  label.push(`Total: ${this.chartData[1]}`);

                } else {
                  label = [data.labels[index] + ': ' + this.chartData[index]]
                }

                return label;
              }
            }
          }
        };

        this.renderChart(data, options)
      }
    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>
